import { render, staticRenderFns } from "./Noordkasteel.vue?vue&type=template&id=477ebe95&"
import script from "./Noordkasteel.vue?vue&type=script&lang=ts&"
export * from "./Noordkasteel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports